import hull_img from '../hullR1/img/hull.jpg'

const HullR2Page = [
  {
    type: 'header',
    value: 'Hull Keyboard Case Preorder $85'
  },
  {
    type: 'text',
    value: 'Hull is a bottom mount low profile case for MiniVan compatible PCBs.'
  },
  {
    type: 'text',
    value: 'These cases are expected to ship in early March 2022. The following items are included.'
  },
  {
    type: 'list',
    values: [
      'Raw aluminum case',
      '(4) M2x6 screws',
      '(Arrow Layout) FR4 Plate',
      '(JetVan Layout) FR4 Plate',
      '(4) Cork Feet'
    ]
  },
  {
    type: 'image',
    value: hull_img
  }
]

export default HullR2Page;
